import React from 'react'

interface Props {
    children?: React.ReactNode
}
const HorizontalCardRightBottom: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default HorizontalCardRightBottom
